import { render, staticRenderFns } from "./OrganismAccordion.vue?vue&type=template&id=07a6b092&scoped=true&"
import script from "./OrganismAccordion.vue?vue&type=script&lang=js&"
export * from "./OrganismAccordion.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAccordion.vue?vue&type=style&index=0&id=07a6b092&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6b092",
  null
  
)

export default component.exports